import { IMapTopologyService } from "../map/topo/types"
import { getLargestLineFromArray, getLargestPolygonFromArray, isFeatureLine, isFeaturePoint } from "../map/utils"
import { ol_polygonFromCircle, ol_geom, ol_Feature, ol_source } from "@omnia/exports/openlayers";

export function clipToBoundary(feature: ol_Feature, boundary: ol_geom.Geometry, topo: IMapTopologyService) {

    if (isFeaturePoint(feature)) {
        clipPointToBoundary(feature, boundary)
        return
    }

    let geom = feature.getGeometry();

    if (geom instanceof ol_geom.Circle) {
        geom = ol_polygonFromCircle(<ol_geom.Circle>geom, 64);
    }

    let result = topo.intersection(geom, boundary);

    if (result) {

        geom = result.getOpenLayersGeometry();

        if (geom) {

            if (isFeatureLine(feature)) {
                geom = getLargestLineFromArray([geom]);
            }
            else {
                geom = getLargestPolygonFromArray([geom]);
            }

            feature.setGeometry(geom);

        }

    }

}

export function clipPointToBoundary(feature: ol_Feature, boundary: ol_geom.Geometry) {


    const point = (<ol_geom.Point>(feature.getGeometry())).getCoordinates()

    const updatedPoint = getClosestPointOnBoundary(point, boundary)

    if (point != updatedPoint) {
        feature.setGeometry(new ol_geom.Point(point))
    }

}

export function clipSegmentToBoundary(feature: ol_Feature, boundary: ol_geom.Geometry) {

    const geom = feature.getGeometry()
    if (!(geom instanceof ol_geom.LineString)) return

    const coords = geom.getCoordinates()
    if (coords.length != 2) return

    const [p1, p2] = coords

    const dx = p2[0] - p1[0]
    const dy = p2[1] - p1[1]

    const center = [p1[0] + (dx / 2), p1[1] + (dy / 2)]

    const updated = getClosestPointOnBoundary(center, boundary)

    if (center != updated) {
        geom.translate(updated[0] - center[0], updated[1] - center[1])
    }

}


export function getClosestPointOnBoundary(point: number[], boundary: ol_geom.Geometry) {

    if (!(boundary instanceof ol_geom.Polygon)) return point

    let outerRing = boundary.getLinearRing(0);
    if (!outerRing) return point

    let polygon = new ol_geom.Polygon([outerRing.getCoordinates()])

    let source = new ol_source.Vector({
        features: [new ol_Feature(polygon)],
        useSpatialIndex: true
    });

    const matches = source.getFeaturesAtCoordinate(point)

    if (matches.length) {
        return point
    }

    const updatedPoint = polygon.getClosestPoint(point)

    return updatedPoint

}
